const features = {
  theShop: 'theShop',
  candleSubscription: 'candleSubscription',
  fragranceFamiliesPage: 'fragranceFamiliesPage',
  noteLibPages: 'noteLibPages',
  addQuebecToCanada: 'addQuebecToCanada',
  recurlyKountDDC: 'recurlyKountDDC', // EP-1113
  privateSale: 'privateSale', // EP-730
  twoThreePerfumesPopup: 'twoThreePerfumesPopup',
  wallet: 'wallet',
  defaultCoupon50: 'defaultCoupon50', // PF-892
  hideCancelSubscriptionButton: 'hideCancelSubscriptionButton', // EP-1424
  additionalResubscribePopup: 'additionalResubscribePopup', // EP-1450
  jasonWuGwp: 'JasonWuGwp', // SB-2811
  giftSubscriptionBanner: 'giftSubscriptionBanner', // EP-1904
  newLastShipmentReviewLogic: 'newLastShipmentReviewLogic', // SB-3795
  scentPreferences: 'scentPreferences', // EP-1630
  serviceWorker: 'serviceWorker', // EP-1603
  giftSetsPage: 'giftSetsPage',
  multipleMerchantsForAmazonPay: 'multipleMerchantsForAmazonPay', // EP-1369
  fragranceCatalogStickyFooter: 'fragranceCatalogStickyFooter', // EP-1446,
  theEdit: 'theEdit', // PF-1242
  candleClubMoreBanners: 'candleClubMoreBanners', // CRO-26
  partytown: 'partytown', // PF-1185
  techCartContinueBar: 'techCartContinueBar', // CRO-72
  collaborationSaks: 'collaborationSaks', // PF-1389
  fillYourQueueSweepstakes: 'fillYourQueueSweepstakes', // PF-1668
  giftCardFraud: 'giftCardFraud', // EP-1846
  optInPopups: 'optInPopups', // PF-1279
  freeShippingProgressBar: 'freeShippingProgressBar', // EP-1845
  caseSubPromoPopup: 'caseSubPromoPopup', // EP-1839
  magicLinkWeb: 'magicLinkWeb', // EP-1869
  popupsLoader: 'popupsLoader',
  cotyNYNJ: 'cotyNYNJ', // PF-1411
  strapiBanners: 'strapiBanners', // PF-1464
  holiday: 'holidaygifthub22', // EP-1935
  giftHubNotification: 'giftHubNotification', // EP-1989
  giftHubValentinesDay: 'giftHubValentinesDay', // PF-1638
  holiday22SaleBadge15: 'holiday22SaleBadge15', // EP-1931
  holiday22SaleBadge20: 'holiday22SaleBadge20', // EP-1931
  holidayCatalogue: 'holidayCatalogue', // EP-1939
  holiday22Sub60: 'holiday22Sub60', // EP-1916
  holiday22CardUpdate60: 'holiday22CardUpdate60', // EP-1925
  holiday22Resubscribe60: 'holiday22Resubscribe60', // EP-1924
  giftSetProductPage: 'giftSetProductPage', // EP-2005
  blackFridayTopHomePageBanner: 'blackFridayTopHomePageBanner',
  cyberMondayTopHomePageBanner: 'cyberMondayTopHomePageBanner',
  holiday22BrandedGWP: 'holiday22BrandedGWP', // PF-1569
  holiday22GiftSubscriptionOffer: 'holiday22GiftSubscriptionOffer', // PF-1570
  holiday22GiftWithSpendThreshold: 'holiday22GiftWithSpentThreshold', // PF-1567
  holiday22GiftWithSpendThresholdProgress: 'holiday22GiftWithSpentThresholdProgress', // PF-1567
  holidayBannerUpdate: 'holidayBannerUpdate', // EP-1977
  holidayBannerUpdateV2: 'holidayBannerUpdateV2', // EP-2007
  holiday22BuyYourQueue: 'holiday22BuyYourQueue', // PF-1568
  seoStrapi: 'seoStrapi', // EP-1823
  cartEcommercePromos: 'cartEcommercePromos', // PF-1564
  cacheForBots: 'cacheForBots', // EP-1962
  addonsPhase1Candle: 'addonsPhase1Candle', // PF-1683
  addonsPhase1Case: 'addonsPhase1Case', // PF-1683
  // Website takeovers, `featuredBrand` prefix for brand page, `websiteTakeover` prefix for entry points
  strapiFeaturedBrand: 'strapiFeaturedBrand', // PF-1525
  strapiWebsiteTakeover: 'strapiWebsiteTakeover', // PF-1525
  featuredBrandDOS: 'featuredBrandDOS', // PF-1436
  websiteTakeoverDOS: 'websiteTakeoverDOS', // PF-1436
  featuredBrandCommodity: 'featuredBrandCommodity', // PF-1504
  websiteTakeoverCommodity: 'websiteTakeoverCommodity', // PF-1504
  featuredBrandSanctuary: 'featuredBrandSanctuary', // PF-1544
  websiteTakeoverSanctuary: 'websiteTakeoverSanctuary', // PF-1544
  featuredBrandHarmonist: 'featuredBrandHarmonist', // PF-1337
  websiteTakeoverHarmonist: 'websiteTakeoverHarmonist', // PF-1337
  featuredBrandMercedesBenz: 'featuredBrandMercedesBenz', // PF-1586
  websiteTakeoverMercedesBenz: 'websiteTakeoverMercedesBenz', // PF-1586
  featuredBrandGoodhabit: 'featuredBrandGoodhabit', // PF-1630
  websiteTakeoverGoodhabit: 'websiteTakeoverGoodhabit', // PF-1630
  attentiveCollectPhoneNumber: 'attentiveCollectPhoneNumber', // EP-2021
  scentbirdPodcastEntryPoints: 'scentbirdPodcastEntryPoints', // PF-1682
  scentHoroscope: 'scentHoroscope', // PF-1626
  postClickVWO: 'postClickVWO',
  faro: 'faro', // EP-2057
  newrelicWeb: 'newrelicWeb', // EP-2057
  shopSamples: 'shopSamples', // EP-2037
  strapiDynamicPage: 'strapiDynamicPage', // PF-1657
  mobileAppEntryPoint: 'mobileAppEntryPoint', // EP-2046
  ssrApiCache: 'ssrApiCache', // EP-2133
  saksGreyCase: 'greyCaseForSaksGwp', // PF-1706
  hideCasesReviews: 'hideCasesReviews', // EP-2145
  limitedDrops: 'limitedDrops', // PF-1695
  coarPhysicalRebrand: 'coarPhysicalRebrand', // PF-1751
  googleGSI: 'googleGSI', // EP-1810
  holidayMothersDay: 'holidayMothersDay', // PF-1768
  driftEcommerce: 'driftEcommerce', // PF-1715
  travelSizeFragrances: 'travelSizeFragrances', // EP-2099
} as const


export type FeatureName = typeof features[keyof typeof features]

export default features
